import product1 from "./assets/products/1.jpg";
import product2 from "./assets/products/2.webp";
import product3 from "./assets/products/3.jpg";
import product4 from "./assets/products/4.jpg";
import product5 from "./assets/products/5.jpg";
import product6 from "./assets/products/6.jpg";
import product7 from "./assets/products/7.jpg";
import product8 from "./assets/products/8.jpg";
import product9 from "./assets/products/9.jpg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "DAZY Zipper Front Hooded Puffer Thick Pockets Coat",
    price: 449,
    productImage: product1,
  },
  {
    id: 2,
    productName: "DAZY Solid Hooded Winter Thick Pockets Coat",
    price: 549,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Frenchy Solid Turtleneck Knit Top",
    price: 899,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Turtleneck Raglan Sleeve Split Hem Sweater",
    price: 699,
    productImage: product4,
  },
  {
    id: 5,
    productName: "LUNE Drop Shoulder Teddy Hoodie & Pants",
    price: 819,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Drawstring Drop Shoulder Thermal Lined Hoodie & Sweatpants",
    price: 979,
    productImage: product6,
  },
  {
    id: 7,
    productName: "LUNE Color Block Drop Shoulder Drawstring Hem Hoodie & Sweatpants",
    price: 449,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Mulvari Colorblock Pocket Front Hoodie and Contrast Sideseam Pants Set",
    price: 399,
    productImage: product8,
  },
  {
    id: 9,
    productName: "Mulvari Mock Neck Lantern Sleeve Lace Insert Dress",
    price: 1399,
    productImage: product9,
  },
];
